import React from "react";
import classNames from "classnames";

const InlineGroup = ({htmlFor, label, children, error, className = '', inputClass = '', ...props}) => {

    return (
        <div className={`${className || ''}`}>
            <div className="flex flex-row flex-wrap">
                {children}
            </div>
            <div>
                {error && <p data-error={true} className={'text-error text-xs'}>{error}</p>}
            </div>
        </div>
    );
}

const Default = ({htmlFor, label, children, error, className = '', inputClass = '', disabled, ...props}) => {

    return (
        <div className={`${className || ''}`}>
            <div className={`input-container ${inputClass || ''}`}>
                {children}
                <label className={`${disabled ? 'disabled':''}`} htmlFor={htmlFor}>{label}</label>
            </div>
            <div>
                {error && <p data-error={true} className={'text-error text-xs'}>{error}</p>}
            </div>
        </div>
    );
}

const Select = ({options = [], className = '', inputClass = '', light, label, error, ...props}) => {
    return (
        <div className={`${className || ''}`}>
            <div className={`input-container ${inputClass || ''}`}>
                <label>{label}</label>
                <select {...props}>
                    <option value="">&mdash;</option>
                    {options.map(item => <option key={item?.value || item} value={item?.value || item}>{item?.label || item}</option>)}
                </select>
                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                    <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                </div>
            </div>
            <div>
                {error && <p data-error={true} className={'text-error text-xs'}>{error}</p>}
            </div>
        </div>
    )
};

function Checkbox ({name, label, error, onChange, checked, light, className = '', children}){
    return (
        <div className={`${className || ''}`}>
            <label className="flex items-center space-x-3">
                <input
                    checked={checked}
                    onChange={onChange}
                    type="checkbox"
                    name={name}
                    className="form-tick checkbox"
                />
                <span className={`font-semibold text-base flex-1 ${light ? 'text-white':'text-gray-900'}`}>{label ? label : children}</span>
            </label>
            {error && <p data-error={true} className="text-error text-xs mt-1">{error}</p>}
        </div>
    )
}

const RadioInsideGroup = ({className, error, children, ...props}) => (
    <div className={`${className} flex flex-col-reverse`}>
        {error && <p data-error={true} className="text-error text-xs mt-1">{error}</p>}
        <div className={`${className} form-radio-group`}>{children}</div>
    </div>
);

const RadioInside = ({htmlFor, label, description, cover, children, className = '',...props}) => {
    return (
        <label className={`w-full flex flex-col multichoice ${className}`}>
            <div className="w-full inline-flex items-center">
                <input type="radio" className="form-radio text-yellow-500" {...props} />
                {/* <span className="form-radio text-gray-800 border-2 border-gray-400 mr-4" style={{height:"0.8rem", width:"0.875rem", marginTop:"-2px",}} aria-hidden="true" /> */}
                <div className="flex-col">
                    <p className="flex-none">
                        <span className="title">{label}</span>
                        {description && <br />}
                        {description && <span className="desc">{description}</span>}
                    </p>
                    {cover && (
                    <div className="mt-2">
                        <img className="max-w-full h-auto" src={cover} alt={label} />
                    </div>
                    )}
                </div>
            </div>
            {children && (
                <div className="mt-3 ml-6 mr-auto">
                    {children}
                </div>
            )}
        </label>
    );
};

export default {
    Default,
    InlineGroup,
    Select,
    Checkbox,
    RadioInsideGroup,
    RadioInside
};
